<template>
  <el-upload
    class="avatar-uploader container-box"
    :action="actionUrl"
    :headers="header"
    :show-file-list="false"
    :on-success="onSuccess"
    :before-upload="beforeUpload"
    :disabled="!isEdit"
  >
    <el-image class="container-box" v-if="userImageUrl" :src="userImageUrl"></el-image>
    <!-- <img v-if="userImageUrl" :src="userImageUrl" class="avatar" /> -->
    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
  </el-upload>
</template>

<script>
import { mapGetters } from "vuex";
import defaultImage from "@/assets/images/UserImage.png";
export default {
  name: "UserImage",
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    imageUrl: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters(["token"]),
    actionUrl() {
      return process.env.VUE_APP_System_Api + "/api/user/editheadimage";
    },
    userImageUrl() {
      // return process.env.VUE_APP_System_Api + this.imageUrl;
      //  return ''
      if (this.imageUrl) return process.env.VUE_APP_System_Api + this.imageUrl;
      else return defaultImage;
    },
    header() {
      return {
        usertoken: this.token,
        ModuleId: "",
        ClientType: 1,
        ClientIp: this.$store.state.app.clientIp,
        params: { path: "User/HeadImages" },
      };
    },
  },
  // watch: {
  //   imageUrl:{
  //        handler(value){
  //          debugger
  //          if (value) this. userImageUrl=process.env.VUE_APP_System_Api + this.imageUrl;
  //     else this. userImageUrl= "@/assets/images/logo.png";
  //     },
  //     immediate: true,
  //   }
  // },
  data() {
    return {};
  },
  methods: {
    onSuccess(res, file, fileList) {
      if (res.Code === 200) {
        this.$emit("refresh");
        this.$emit("refreshUrl", res.Data);
        this.$successMessage("上传成功");
      } else {
        this.$errorMessage(res.Message);
      }
    },
    beforeUpload() {},
  },
};
</script>

<style lang="scss" scoped>
.avatar-uploader {
  width: 60px;
  height: 60px;
  text-align: center;
  margin: 0 auto;
  border-radius: 100%;
  overflow: hidden;
  border: 5px solid #fff;
  box-shadow: 0 0 5px #000;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 130px;
  height: 130px;
  line-height: 130px;
  text-align: center;
}
.avatar {
  width: 130px;
  height: 130px;
  display: block;
}
>>>.el-upload{
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/User/UserImage.vue